import React from 'react';
import HeroImage from '../../../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../../../assets/images/services/banking-license/page-banner.png'

import BreadCrumbs from "../../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../../components/Constant/List/List";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../../components/Constant/cta/CTA";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../../components/Constant/button/Button";
import SEO from "../../../../utils/SEO";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Isle of Man Banking & FinTech License',
        link: '/isle-man-banking-fintech-license',
    },
]

function IsleManBankingFinTechLicense () {

    return (
        <main className='main'>
            <SEO
                title="Isle of Man Banking & FinTech License | IOMFSA"
                description="Obtain an Isle of Man license for banking, PSPs, EMIs, and blockchain finance. Regulated by IOMFSA with strong global credibility."
                keywords="Isle of Man banking license, IOMFSA license, Isle of Man fintech license, PSP license Isle of Man, EMI license IoM, blockchain finance Isle of Man, offshore financial license, digital banking jurisdiction"
                url="/isle-man-banking-fintech-license"
            />
            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>
                        Isle of Man Banking & FinTech License
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                A Tier-1 Jurisdiction for Banking, PSPs & Blockchain Finance
                            </h3>
                            <p className='page-paragraph'>
                                A <b>Tier-1 Jurisdiction</b> for <b>Banking, PSPs & Blockchain Finance</b>
                                <br/>
                                The <b>Isle of Man (IoM)</b> is globally recognized as a <b>leading offshore financial center</b> for <b>banking, fintech, and digital finance</b>.
                                <br/>
                                The jurisdiction is home to <b>international banks, payment providers, electronic money institutions (EMIs), and blockchain innovators</b>, all supervised by the <b>Isle of Man Financial Services Authority (IOMFSA)</b>.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "Banking",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Payment Service Providers (PSPs)",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "EMIs",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Blockchain Finance",
                                        icon: GoDotFill,
                                    },
                                ]}
                            />

                            <Button
                                text="Request an Isle of Man Banking Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Choose Isle of Man for Banking & FinTech?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Tier-1 Reputation",
                                    paragraph: "Trusted by global regulators, banks, and investors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Respected Regulator",
                                    paragraph: "IOMFSA ensures solvency and compliance",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Crypto & Blockchain Friendly",
                                    paragraph: "Early adoption of digital asset regulation",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Benefits",
                                    paragraph: "0% corporate tax (except local banking profits)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investor Confidence",
                                    paragraph: "Perfect for institutional and fintech scaling",
                                    icon: GoDotFill,
                                },
                            ]}
                        />


                        <h3 className='page-title'>Types of Financial Licenses in the Isle of Man</h3>
                        <p className='page-subtitle'>1. Banking License</p>
                        <PageList
                            items={[
                                { paragraph: "For institutions offering retail, private, or corporate banking.", icon: GoDotFill },
                                { paragraph: "Strict solvency, compliance, and capital requirements.", icon: GoDotFill },
                                { paragraph: "Suitable for wealth management, custody, and investment banks.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>2. Payment Service Provider (PSP) License</p>
                        <PageList
                            items={[
                                { paragraph: "For firms providing merchant acquiring, processing, and payment gateways.", icon: GoDotFill },
                                { paragraph: "Ideal for e-commerce and iGaming operators.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>3. Electronic Money Institution (EMI) License</p>
                        <PageList
                            items={[
                                { paragraph: "For issuing e-wallets, prepaid cards, and digital payment platforms.", icon: GoDotFill },
                                { paragraph: "Often used by fintech and blockchain startups.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>4. Blockchain & Digital Finance Licenses</p>
                        <PageList
                            items={[
                                { paragraph: "Covers crypto exchanges, tokenized assets, and blockchain payment solutions.", icon: GoDotFill },
                                { paragraph: "The Isle of Man was an early pioneer in Bitcoin regulation.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>Capital & Requirements</p>
                        <PageList
                            items={[
                                { paragraph: "Banking License: GBP 5m+ in paid-up capital.", icon: GoDotFill },
                                { paragraph: "PSP/EMI License: GBP 100k–350k depending on risk.", icon: GoDotFill },
                                { paragraph: "Entity: Isle of Man-incorporated company.", icon: GoDotFill },
                                { paragraph: "Resident Presence: at least 2 local directors + compliance officer.", icon: GoDotFill },
                                { paragraph: "Office: physical presence required.", icon: GoDotFill },
                                { paragraph: "Compliance: AML/KYC, risk management frameworks.", icon: GoDotFill },
                                { paragraph: "Audit: annual audited accounts.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of Isle of Man Banking & FinTech License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Institutional Grade",
                                    paragraph: "Credibility with banks & investors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Regulatory Strength",
                                    paragraph: "IOMFSA recognized globally",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Crypto-Friendly",
                                    paragraph: "Blockchain PSPs & exchanges accepted",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investor Confidence",
                                    paragraph: "Attracts capital markets and funds",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Global Reach",
                                    paragraph: "Access to EU and Commonwealth markets",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Licensing Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Pre-Application Consultation",
                                    paragraph: "Define banking, PSP, EMI, or blockchain scope",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Entity Incorporation",
                                    paragraph: "Establish Isle of Man company",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Application Preparation",
                                    paragraph: "Business plan, AML/KYC manuals, capital proof",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "IOMFSA Review",
                                    paragraph: "Due diligence on directors, shareholders, and governance",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Approval & Licensing",
                                    paragraph: "Typically 6–12 months",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "6–12 months",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From GBP 75,000+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "GBP 100k–5m depending on license",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "IOMFSA supervision, compliance, audits",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in Banking & FinTech Licensing Worldwide",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-End Support",
                                    paragraph: "Incorporation, filings, AML compliance",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Network of Banks, PSPs, EMIs, and Crypto Partners",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative Insights",
                                    paragraph: "IoM vs Malta vs Gibraltar vs Mauritius",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Long-Term Compliance and Operational Support",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                    </div>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Looking for Tier-1 credibility in banking and fintech?"
                        description=
                            "The <b>Isle of Man</b> offers <b>banking, PSP, EMI, and blockchain licenses</b> under the supervision of the <b>IOMFSA</b>, ideal for <b>institutional and fintech operators</b>."
                        buttonText="Book an Isle of Man Banking & FinTech Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    );
}

export default IsleManBankingFinTechLicense;

const faqData = [
    {
        question: "What’s the difference between General and International Banking Licenses?",
        content: [
            { type: "answer", text: "General = local + international banking. International = offshore-only (non-residents)." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "USD 3M (International), USD 10M (General)." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "9–12 months on average." },
        ],
    },
    {
        question: "Can Panama banks issue cards and IBANs?",
        content: [
            { type: "answer", text: "Yes — many partner with Visa, Mastercard, SWIFT, and SEPA." },
        ],
    },
    {
        question: "Is Panama banking still confidential?",
        content: [
            { type: "answer", text: "Yes — strong asset protection, though aligned with FATF and OECD transparency." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "Our fintech firm secured an EMI license in the Isle of Man. Offshore Advisory handled incorporation and compliance.",
        author: "Jonathan M.",
        role: "FinTech CEO",
    },
    {
        quote:
            "We chose IoM for PSP licensing due to its prestige. Offshore Advisory guided us through IOMFSA approvals.",
        author: "Nadia T.",
        role: "PSP Founder",
    },
];